import { FC, MutableRefObject, useState } from 'react';
import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Booking } from 'src/modules/BookingManagement/models';
import { Dayjs } from 'dayjs';

interface DeliverOrderProps {
  company: any;
  bookingList: Booking[];
  contentToPrint: MutableRefObject<any>;
  startDate: Dayjs;
  endDate: Dayjs;
}
export const DeliverOrder: FC<DeliverOrderProps> = ({ company, bookingList, contentToPrint, startDate,endDate }) => {

  var sectionStyle = {
    width: `21.0cm`,
    height: `29.7cm`,
  };
  
  return (
    <Box className="MuiPageTitle-wrapper PageTitle">
      <div className="invoice-box" style={sectionStyle} ref={contentToPrint} >
        <table cellPadding="0" cellSpacing="0">
          <tr className="top">
            <td colSpan={2}>
              <table>
                <tr>
                  <td className="title">
                    {(company.tenantName)} Deliver order
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr className="information">
            <td colSpan={2}>
              <table>
                <tr>
                  <td>
                    {`Start Date: ${startDate.format('DD/MM/YYYY')}`}
                  </td>
                </tr>
                <tr>
                  <td>
                    {`End Date: ${endDate.format('DD/MM/YYYY')}`}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
            <TableCell>No</TableCell>
              <TableCell>Booking NO</TableCell>
              <TableCell align="right">Name/Mobile</TableCell>
              <TableCell align="right">Asset</TableCell>
              <TableCell align="right">delivary time</TableCell>
              <TableCell align="right">packing status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {
        bookingList?.map((booking: Booking, index) =>(
          booking?.bookingAssets?.map((bookingAsset,idx) =>(
        <TableRow key={`${booking.id}-${bookingAsset.id}`}>
              {idx==0 && <TableCell rowSpan={booking?.bookingAssets?.length || 1}>{index + 1}</TableCell>}
              {idx==0 &&<TableCell rowSpan={booking?.bookingAssets?.length|| 1}>{booking?.billNo}</TableCell>}
              {idx==0 &&<TableCell rowSpan={booking?.bookingAssets?.length|| 1} align="right">{booking?.name} - {booking?.mobile}</TableCell>}
              <TableCell align="right">{bookingAsset?.asset?.code}-{bookingAsset?.asset?.name}</TableCell>
              <TableCell align="right">{new Date(bookingAsset?.deliveryDate).toLocaleString('en-GB', { hour12: true }) || ''}</TableCell>
              <TableCell align="right"></TableCell>
          </TableRow>
          ))
        ))
       }
          </TableBody>
        </Table>
      </div>
    </Box>
  );
};
